import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Image, Button } from "react-bootstrap";
import SlidingComponent from "../../../reusableComponents/slidingToggleComponent/SlidingComponent";
import moment from "moment";
import ReactHtmlParser from "react-html-parser";

import propTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import {
  admin_update_sms_templates,
  admin_update_email_templates,
  admin_update_notification_templates,
  admin_update_send_approval_templates,
  admin_get_perticular_emailSMSNortification_templates,
} from "../../../../store/actions/SuperAdminActions/adminTemplatesAction";
import isEmpty from "../../../../store/validation/is-Empty";
import ToggleButtonPopup from "./allPoup/ToggleButtonPopup";
import DeleteTemplateButtonPopup from "./allPoup/DeleteTemplateButtonPopup";
import OnHoldModalPopup from "./allPoup/OnHoldModalPopup";
import Alert from "react-s-alert";
import { SeatingDashboardTableManagement } from "../../../reusableComponents/allTableReusable/seatingDashboardTable/SeatingDashboardDesktopTableHead";

export const SuperAdminTemplateBody = (props) => {
  const dispatch = useDispatch();
  let history = useHistory();

  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });
  const [Approvebtn,SeApproveBtn]=useState(false);
  const SeatDisable = () => {
    if(props.smsInfo.isApprove === true ||
      props.smsInfo.status === true){
        return true;
      }else {
        return Approvebtn
      }
  }

  /*********************************************
   * @DESC Send Approvel Button Actions Start
   *********************************************/
  const onSendApprovelClick = (templateData, actionBy) => {
    const token = props.auth.user.accessToken;
    const formData = {
      status: templateData.status === true ? false : true,
      isApprove: templateData.isApprove === true ? false : true,
    };
    if (actionBy === "SMS") {
      props.admin_update_sms_templates(
        templateData._id,
        token,
        formData,
        (data) => onSuccess(data, actionBy, token)
      );
    } else if (actionBy === "EMAIL") {
      props.admin_update_email_templates(
        templateData._id,
        token,
        formData,
        (data) => onSuccess(data, actionBy, token)
      );
    } else if (actionBy === "NOTIFICATION") {
      props.admin_update_notification_templates(
        templateData._id,
        token,
        formData,
        (data) => onSuccess(data, actionBy, token)
      );
    }
  };

  if (props?.index === 0 && props?.setLength) {
    props.setLength(props?.filteredDataLength || 0);
  }

  const onSuccess = (data, actionBy, token) => {
    SeApproveBtn(true);
    if (data.isApprove === true && data.isSendLater === false) {
      dispatch(
        admin_update_send_approval_templates(
          data._id,
          token,
          actionBy,
          onSuccessSendApproval(actionBy)
        )
      );
    } else {
      console.log("Send Later");
      props.fetchNew()
      Alert.success(
        `<h4>${actionBy === "SMS"
          ? "SMS"
          : actionBy === "EMAIL"
            ? "Email"
            : actionBy === "NOTIFICATION"
              ? "Notification"
              : ""
        } Template Approval Successfully</h4>`,
        {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        }
      );
    }
  };

  /*********************************************
   * @DESC Send Approvel Button Actions Start
   *********************************************/
  const onSuccessSendApproval = (actionBy) => (e) => {
    console.log("Send Now");
    props.fetchNew()
    Alert.success(
      `<h4>${actionBy === "SMS"
        ? "SMS"
        : actionBy === "EMAIL"
          ? "Email"
          : actionBy === "NOTIFICATION"
            ? "Notification"
            : ""
      } Template Approval Successfully</h4>`,
      {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      }
    );
  };

  /*********************************************
   * @DESC Send Approvel Button Actions Start
   *********************************************/
  const handleEditTemplate = (templateId) => (e) => {
    const token = props.auth.user.accessToken;
    dispatch(
      admin_get_perticular_emailSMSNortification_templates(
        templateId,
        token,
        props.actionPerform,
        onSuccessTemplates
      )
    );
  };

  const onSuccessTemplates = () => {
    history.push({
      pathname: "/super-admin-edit-template",
      state: { actionPerform: props.actionPerform },
    });
  };

  return (
    <React.Fragment>
      <tbody>
        <tr
          className="super_admin_all_users_table_body mt-2"
          style={{ wordBreak: "break-word" }}
        >
          <td colSpan="7" className="p-0 w-100">
            <table className="w-100 HideShowTable enMinWidth900">
              <tbody>
                <tr onClick={showTr}>
                  <td style={{ width: "8%" }}>
                    <div className="f12-400">
                      {props.smsInfo.sms_id !== undefined
                        ? props.smsInfo.sms_id
                        : props.smsInfo.email_id !== undefined
                          ? props.smsInfo.email_id
                          : props.smsInfo.notification_id !== undefined
                            ? props.smsInfo.notification_id
                            : "-"}
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="f12-400">
                      {props.smsInfo.role === 0
                        ? "User"
                        : props.smsInfo.role === 1
                          ? "Vendor"
                          : "-"}
                    </div>
                  </td>
                  <td
                    style={
                      props.actionPerform === "EMAIL"
                        ? { width: "20%" }
                        : { width: "10%" }
                    }
                  >
                    <div className="f12-400">{props.smsInfo.title}</div>
                  </td>
                  {/* <td></td> */}
                  {props.actionPerform === "EMAIL" ? null : (
                    <td style={{ width: "18%" }}>
                      <div className="f12-400">{props.smsInfo.message}</div>
                    </td>
                  )}
                  {/* <div className="w-100">
                    // {ReactHtmlParser(props.smsInfo.message)}
                    //{" "}
                  </div> */}
                  <td
                    style={
                      props.actionPerform === "EMAIL"
                        ? { width: "10%" }
                        : { width: "6%" }
                    }
                    onClick={(e) => {
                      if (!e) var e = window.event;
                      e.cancelBubble = true;
                      if (e.stopPropagation) e.stopPropagation();
                    }}
                  >
                    {/* <SlidingComponent
                      name="status"
                      currentState={props.smsInfo.status}
                      type={"checkbox"}
                      toggleclass={
                        "toggle vendor-super-admin-toggle d-flex align-items-center mb-2"
                      }
                      toggleinputclass={
                        "toggle__switch vendor-super-admin-toggle"
                      }
                      onChange={() => onChangeStatus(props.smsInfo.status)}
                      defaultChecked={props.smsInfo.status ? true : false}
                    /> */}
                    <ToggleButtonPopup
                      diameter={24}
                      height={15}
                      width={41}
                      activeProps={props.smsInfo}
                      actionBy={props.actionPerform}
                    />
                  </td>
                  <td
                    style={
                      props.actionPerform === "EMAIL"
                        ? { width: "12%" }
                        : { width: "8%" }
                    }
                  >
                    <div className="f12-400">
                      {props.smsInfo.frequency === 0
                        ? "Hourly"
                        : props.smsInfo.frequency === 1
                          ? "Daily"
                          : props.smsInfo.frequency === 2
                            ? "Weekly"
                            : props.smsInfo.frequency === 3
                              ? "Monthly"
                              : props.smsInfo.frequency === 4
                                ? "Yearly"
                                : "-"}
                    </div>
                  </td>
                  <td style={{ width: "9%" }}>
                    <div className="f12-400">
                      {moment(props.smsInfo.startDate).format("Do MMM YYYY")}
                    </div>
                  </td>
                  <td style={{ width: "9%" }}>
                    <div className="f12-400">
                      {moment(props.smsInfo.endDate).format("Do MMM YYYY")}
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="f12-400">
                      {!props?.smsInfo?.isSendLater ? "-" : (
                        <>
                        {moment(props.smsInfo.startTriggeredAt).format("hh:mm A")}
                        </>
                      )}
                      
                    </div>
                  </td>
                  <td
                    style={{ width: "12%" }}
                    // onClick={(e) => {
                    //   if (!e) var e = window.event;
                    //   e.cancelBubble = true; 
                    //   if (e.stopPropagation) e.stopPropagation();
                    // }}
                  >
                    <Button
                      variant="danger"
                      className="px-2 py-2 btn f10-400 text-white"
                      disabled={SeatDisable()}
                      // style={
                      //   props.smsInfo.isApprove === true ||
                      //     props.smsInfo.status === true
                      //     ? { backgroundColor: "#E0E0E0" }
                      //     : { backgroundColor: "#EE3A23" }
                      // }
                      onClick={
                        props.smsInfo.isApprove === true ||
                          props.smsInfo.status === true
                          ? () => console.log()
                          : () =>{
                            onSendApprovelClick(
                              props.smsInfo,
                              props.actionPerform
                            );
                            SeApproveBtn(true) 
                          }
                      }
                    >
                      Send Approval
                    </Button>
                  </td>
                </tr>
                {TrDetail.TrDetail && (
                  <tr className="border-top">
                    <td style={{ width: "25%" }}>
                      <div className="f12-500 mb-2">More Actions</div>
                      <div className="d-flex align-items-center">
                        {props.smsInfo.isSendLater ? (
                          ""
                        ) : (
                          <OnHoldModalPopup
                            dataInfo={props.smsInfo}
                            actionBy={props.actionPerform}
                          />
                        )}
                        <Button
                          variant="link"
                          type="button"
                          className="enIconBtn mr-3"
                          //   onClick={handleShowDeleteOffer}
                          onClick={handleEditTemplate(props.smsInfo._id)}
                        >
                          <Image
                            src={require("../../../../assets/images/UserManagement/pencil.svg")}
                            alt="Edit"
                            title="Edit"
                            fluid
                          />
                        </Button>
                        <DeleteTemplateButtonPopup
                          dataInfo={props.smsInfo}
                          actionBy={props.actionPerform}
                        />
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </React.Fragment>
  );
};

SuperAdminTemplateBody.propTypes = {
  auth: propTypes.object.isRequired,
  errors: propTypes.object.isRequired,
  admin_update_sms_templates: propTypes.func.isRequired,
  admin_update_email_templates: propTypes.func.isRequired,
  admin_update_notification_templates: propTypes.func.isRequired,
  admin_update_send_approval_templates: propTypes.func.isRequired,
  admin_get_perticular_emailSMSNortification_templates:
    propTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  admin_update_sms_templates,
  admin_update_email_templates,
  admin_update_notification_templates,
  admin_update_send_approval_templates,
  admin_get_perticular_emailSMSNortification_templates,
})(withRouter(SuperAdminTemplateBody));
